// input: h in [0,360] and s,v in [0,1] - output: r,g,b in [0,255]
export const hsv2rgb = (h, s, v) => {
  let f = (n, k = (n + h / 60) % 6) => v - v * s * Math.max(Math.min(k, 4 - k, 1), 0)
  return [f(5), f(3), f(1)].map(c => Math.round(c * 255))
}

export const rgb2hex = ([r, g, b]) => '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)
